module.exports = __webpack_public_path__ + "static/USWPS-7f6b88c833d11786b14e30299a1b35e9.svg";